import { Component, EventEmitter, Output, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { WalletSetupService } from 'src/app/shared/services/api/wallet-setup.service';

@Component({
  selector: 'app-modal-unenroll-nextgen',
  templateUrl: './modal-unenroll-nextgen.component.html',
  styleUrls: ['./modal-unenroll-nextgen.component.scss']
})
export class ModalUnenrollNextgenComponent {
 @Output() confirm = new EventEmitter<void>(); // Triggers Unenroll
  @Output() cancel = new EventEmitter<void>();  // Triggers Stay Enrolled

  // Variable to track the checkbox state
  isAgreed: boolean = false;
  isLoading: boolean = false;

  constructor(
    private walletSetupService: WalletSetupService,
private auth: AuthService, // <-- Inject AuthService
    @Inject(DOCUMENT) private document: Document // <-- Inject Document for origin URL
  ) {}

  // "Stay Enrolled" or "X" button
  onCancel(): void {
    this.cancel.emit();
  }


onConfirm(): void {
    if (this.isAgreed) {
      console.log('User agreed and confirmed unenrollment');
      this.isLoading = true; 

      const walletId = (sessionStorage.getItem('WalletID') || '').replace(/"/g, '');
      const sessionId = sessionStorage.getItem('SessionID') || '';

      // 1. Prepare the payload to set T&C to 0
      const tcDeclineData = {
        walletId: walletId,
        sessionID: sessionId,
        productType: 'UPSdotcom', 
        productSourceSystem: 'UPSdotcom',
        tcAcceptance: '0' 
      };

      // 2. Call the setup API to register the T&C decline first
      this.walletSetupService.updateWalletSetupNextGen(tcDeclineData).subscribe({
        next: (setupRes) => {
          console.log('✅ T&C successfully set to 0 for unenrollment', setupRes);

          // 👇👇👇 HERE IS YOUR INACTIVE STATUS 👇👇👇
          const newStatus = 'deleted';
          
          // 3. We pass 'newStatus' right here into your original API call!
          this.walletSetupService.updateWalletStatus(walletId, sessionId, newStatus).subscribe({
            next: (res) => {
              this.isLoading = false;
              console.log('Unenroll successful:', res);

              if (res.message === 'DWUpdateWalletStatus was successful.') {
                
                sessionStorage.clear();
                localStorage.clear();

                // Drop the flag to bounce to UPS.com
                localStorage.setItem('redirectToUps', 'true');

                // Perform safe Auth0 Logout
                this.auth.logout({ 
                  logoutParams: { 
                    returnTo: this.document.location.origin + '/next-gen-login'
                  }
                });
              }
            },
            error: (error) => {
              this.isLoading = false;
              console.error('❌ Error during unenrollment API call:', error);
            }
          });
          // 👆👆👆 END OF SECOND API CALL 👆👆👆

        },
        error: (error) => {
          this.isLoading = false;
          console.error('❌ Failed to update T&C to 0 before unenrollment:', error);
        }
      });
    }
  }

  // Toggle checkbox state
  toggleAgreement(event: any): void {
    this.isAgreed = event.target.checked;
  }
}